const SMS_QUOTE = "sms:+13214202707?body=Hi%20DUMP'D!%20I'd%20like%20a%20free%20junk%20removal%20quote.";
const SMS_PHOTO = "sms:+13214202707?body=Hi%20DUMP'D!%20Here's%20what%20I%20need%20removed:";

const TIERS = [
  { label: "SMALL", price: "$89", examples: ["A few items", "Bags & boxes", "Small junk pickups"], featured: false },
  { label: "MEDIUM", price: "$249", examples: ["Furniture removal", "Garage cleanouts", "Room cleanouts"], featured: true },
  { label: "LARGE", price: "$449", examples: ["Large cleanouts", "Multiple rooms", "Large junk loads"], featured: false },
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 bg-neutral-950 border-t border-white/10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-xs font-mono tracking-[0.3em] text-zinc-400 mb-4">DUMP'D JUNK REMOVAL</p>
        <h2 className="text-4xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tighter font-display text-white leading-[0.95]">
          Simple Pricing.<br />No Surprises.
        </h2>
        <p className="max-w-xl mx-auto mt-6 mb-12 text-zinc-400 text-sm sm:text-base leading-relaxed">
          Choose the load size that best matches your cleanup. Final pricing depends on volume, weight, material type and access.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TIERS.map((t) => (
            <div
              key={t.label}
              data-testid={`price-card-${t.label.toLowerCase()}`}
              className={`relative bg-zinc-950 rounded-2xl px-7 pt-11 pb-8 transition-transform duration-200 hover:-translate-y-1.5 ${
                t.featured ? "border-2 border-white" : "border border-zinc-800 hover:border-white/60"
              }`}
            >
              {t.featured && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-white text-black px-4 py-1.5 rounded-full text-[10px] font-black tracking-widest uppercase">
                  Popular
                </span>
              )}
              <div className="text-2xl font-black uppercase text-white font-display">{t.label}</div>
              <p className="text-zinc-500 text-[11px] font-mono tracking-[0.25em] mt-5 mb-1">STARTING AT</p>
              <div className="text-6xl font-black text-white font-display leading-none">{t.price}</div>
              <div className="w-11 h-0.5 bg-white mx-auto my-6" />
              <div className="text-zinc-300 text-sm leading-loose min-h-[96px]">
                {t.examples.map((ex) => (
                  <p key={ex}>{ex}</p>
                ))}
              </div>
              <a
                href={SMS_QUOTE}
                data-testid={`quote-btn-${t.label.toLowerCase()}`}
                className="block mt-6 py-4 rounded-lg bg-white text-black font-black uppercase text-xs tracking-wider hover:bg-zinc-200 transition-colors"
              >
                Get Free Quote
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 py-11 px-6 border-y border-zinc-800">
          <h3 className="text-2xl sm:text-3xl font-black uppercase text-white font-display">Not Sure Which Size?</h3>
          <p className="text-zinc-400 text-sm mt-2 mb-6">Text us a photo of what you need removed and we'll provide a free quote.</p>
          <a
            href={SMS_PHOTO}
            data-testid="text-photo-btn"
            className="inline-block bg-white text-black font-black uppercase text-xs tracking-wider px-8 py-4 rounded-lg hover:bg-zinc-200 transition-colors"
          >
            Text a Photo — (321) 420-2707
          </a>
        </div>

        <p className="max-w-2xl mx-auto mt-8 text-zinc-500 text-xs leading-relaxed">
          *Prices shown are starting prices. Final price may vary depending on volume, weight, material, disposal fees, location and accessibility. Certain heavy or specialty materials may be priced separately.
        </p>
      </div>
    </section>
  );
}
